import React, { useState, useContext, useEffect } from 'react';
import useInterval from 'hooks/useInterval';
import GlobalContext from "context/globalContext";
import { OTSession, OTPublisher } from 'opentok-react';
import useSignalR from "hooks/useSignalR";
import photoService from "services/photoService";
import sessionService from "services/sessionService";
import { Button } from "react-bootstrap";
import config from 'config';
import "styles/customer.css";
import errorLogging from "errorLogger";

function Customer(props) {
    const globalContext = useContext(GlobalContext);
    const signalRConnection = useSignalR(globalContext.sessionId, "Customer");
    const [isAdminConnectedCount, setIsAdminConnectedCount] = useState(0);
    const otPublisher = React.createRef();

    /* Check every minute that admin is connected */
    useInterval(async () => {
        const isConnected = await sessionService.checkIsAdminConnected(globalContext.sessionId);
        if (!isConnected) {
            setIsAdminConnectedCount(isAdminConnectedCount + 1);
        }
    }, 60000);

    /* Use Effects */
    useEffect(() => {
        globalContext.session.fetch(globalContext.sessionId, false);
        globalContext.customer.getLocation();
        // eslint-disable-next-line 
    }, []);

    //When geolocation is set or changed, set geolocatin ready to send, and send as soon as singleRconnection is true
    useEffect(() => {
        if (globalContext.customer.response &&
            globalContext.customer.response.geolocation &&
            globalContext.session.response.signalRConnected
        ) {
            let coords = globalContext.customer.response.geolocation.coords;

            signalRConnection.invoke('sendLocation',
                globalContext.sessionId,
                coords.accuracy,
                coords.altitude,
                coords.altitudeaccuracy,
                coords.speed,
                coords.latitude,
                coords.longitude);
        }
    }, [globalContext.customer.response, globalContext.session.response.signalRConnected])

    /* if admin isnt connectd for 3 minutes, kill connection */
    useEffect(() => {
        let disconnect = async () => {
            await globalContext.session.disconnect(globalContext.sessionId);
            window.location.href = "https://www.hbiaustralia.com.au";
        }
        if (isAdminConnectedCount >= 3) {
            disconnect();
        }
    }, [isAdminConnectedCount])

    /* Events */
    if (signalRConnection) {
        signalRConnection.off('takeSnapShot');
        signalRConnection.on('takeSnapShot', (photoId) => {
            if (otPublisher) {
                const subscriber = otPublisher.current.getPublisher();

                photoService.uploadPhoto(subscriber.getImgData(),
                    globalContext.sessionId,
                    null,
                    photoId,
                    (progress) => {
                        signalRConnection.invoke('uploadProgress', globalContext.sessionId, photoId, progress);
                    },
                    (response) => {
                        signalRConnection.invoke('uploadDone', globalContext.sessionId, photoId, response.data);
                        console.log("success", response);
                    });
            }

        });

        signalRConnection.off('cycleCamera');
        signalRConnection.on('cycleCamera', () => {
            if (otPublisher) {
                const subscriber = otPublisher.current.getPublisher();
                subscriber.cycleVideo().then().catch();
            }
        });
    }

    const onClose = () => {
        window.close();
        window.location.href = "http://www.google.com.au/";
    }

    const onRefresh = () => {
        window.location.reload();
    }

    const onRequestFullScreen = () => {
        try {
            if ((window.screen.availHeight || window.screen.height - 30) <= window.innerHeight) {
                exitFullscreen();
            }
            else {
                requestFullScreen();
            }

        }
        catch (ex) {
            console.log("Error getting full screen");
        }
    }

    const requestFullScreen = () => {
        if (document.body.requestFullScreen) {
            document.body.requestFullscreen();
        }
        else if (document.body.webkitRequestFullScreen) {
            document.body.webkitRequestFullScreen();
        }
        else if (document.body.mozRequestFullScreen) {
            document.body.mozRequestFullScreen();
        }
        else if (document.body.mozRequestFullScreen) {
            document.body.mozRequestFullScreen();
        }
    }

    const exitFullscreen = () => {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        }
    }

    /* End Events */


    if (!globalContext.session.response.session) {
        return (
            <div className="App">
                Loading..
            </div>
        )
    }
    else {

        return (
            <div className="customer-app" onDoubleClick={onRequestFullScreen}>
                <Button variant="danger" size="sm" className="refresh-button" onClick={onRefresh} >Refresh</Button>
                <Button variant="danger" size="sm" className="close-button" onClick={onClose}>Close</Button>
                <OTSession
                    apiKey={config.openTokApi}
                    sessionId={globalContext.session.response.session.id}
                    token={globalContext.session.response.session.token}
                    onConnect={() => {
                        console.log("OT connected");
                    }}
                    onError={(err) => {
                        console.log("error", err);
                        window.alert(err.message);
                        errorLogging.sendLog(JSON.stringify(err));
                    }}
                >
                    <OTPublisher properties={{
                        resolution: '1280x720',
                        PreferredResolution: '1280x720',
                        insertMode: 'append',
                        width: "100%",
                        height: "100%",
                        mirror: false,
                        facingMode: "environment",
                        fitMode: "contain",
                        audioFallbackEnabled: false,
                        audioSource: null,
                        publishAudio: false,
                        style: { buttonDisplayMode: 'off' },
                    }}
                        ref={otPublisher}
                        onError={(err) => {
                            console.log("error", err);
                            errorLogging.sendLog(JSON.stringify(err));
                        }}
                    />
                </OTSession>
            </div>
        );
    }
}

export default Customer;
